import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import { reduxForm, initialize, destroy } from 'redux-form'
import { CharField } from 'components/forms'
import ErrorComponent from '../auth/ErrorComponent'
import messages from '../auth/messages'
import { selectAccountDeleteViewRedirectURI } from 'services/site/selectors'
import { FormattedHTMLMessage, FormattedMessage } from 'react-intl'
import { Button } from 'components/util'
import ForgotPassword from '../auth/forgotPassword/ForgotPassword'
import styles from 'components/deletion/_deletion.css'

export const FORM_NAME = 'verifyPassword'

const validate = (values) => {
  const errors = {}
  if (!values.password) { errors.password = 'required' }
  return errors
}

const formOptions = {
  form: FORM_NAME,
  validate,
}

const mapStateToProps = (state) => {
  return {
    disabled: true,
    forgotPasswordRedirectURI: selectAccountDeleteViewRedirectURI(state),
  }
}

const mapDispatchToActions = {
  initialize,
  destroy,
}

export class DeletionForm extends Component {
  static propTypes = {
    intl: PropTypes.object,
    initialize: PropTypes.func,
    handleSubmit: PropTypes.func,
    error: PropTypes.string,
    email: PropTypes.string,
    clearErrors: PropTypes.func,
    invalid: PropTypes.bool,
    pristine: PropTypes.bool,
    dev: PropTypes.bool,
    forgotPasswordRedirectURI: PropTypes.string,
  }

  state = {
    forgotPassword: false,
  }

  handleForgotPassword = (e) => {
    e.preventDefault()

    this.setState({
      forgotPassword: true,
    })

    this.props.clearErrors()
  }

  handleBack = (e) => {
    e.preventDefault()

    this.setState({
      forgotPassword: false,
    })
  }

  render () {
    const { handleSubmit, intl, email, invalid, pristine, forgotPasswordRedirectURI } = this.props
    const { forgotPassword } = this.state

    return (
      <div className={styles.deleteFormContainer}>
        {forgotPassword ?
          <div>
            <ForgotPassword
              redirectURI={forgotPasswordRedirectURI}
            />
            <a className={styles.back} onClick={this.handleBack} href='#'>
              <FormattedMessage id='delete.password.forgot.back' defaultMessage='Back to Account Deletion' />
            </a>
          </div>
        :

          <form method='post' onSubmit={handleSubmit} className={styles.deleteVerifyForm}>

            <h3 className={styles.deleteTitle}>
              <FormattedHTMLMessage
                id='auth.password.verfiy.text'
                defaultMessage={`
                  Enter your password to delete <br />your <strong>Under Armour</strong> account.*
                `}
              />
            </h3>

            <CharField
              slim
              name='password'
              type='password'
              placeholder={intl.formatMessage(messages.password)}
              labelComponent={null}
              className={styles.inputPassword}
              errorComponent={(
                <ErrorComponent name={intl.formatMessage(messages.password)} />
              )}
              normalize={(value) => value.trim()}
            />

            <p className={styles.verifyNote}>
              <FormattedHTMLMessage
                id='delete.password.verify.note'
                defaultMessage={`
                  *Note: This will also delete profiles for UA Record, MapMyRun, MapMyWalk, MapMyFitness,
                  and/or MapMyDogWalk associated with {email}
                `}
                values={{ email: email }}
              />
            </p>
            <p className={styles.secondaryNote}>
              <FormattedHTMLMessage
                id='delete.password.verify.note2'
                defaultMessage='This action will not impact your profiles for MyFitnessPal or the UA Shop app.'
              />
            </p>

            <div className={styles.buttonContainer}>
              <p className={styles.forgotPasswordLink}>
                <a href="#" onClick={this.handleForgotPassword}>
                  <FormattedHTMLMessage
                    id='delete.password.verify.forgotLink'
                    defaultMessage='Forgot Password?'
                  />
                </a>
              </p>

              <Button
                el='button'
                type='success'
                disabled={invalid || pristine}
                className={styles.button}
              >
                <FormattedHTMLMessage
                  id='delete.password.verify.btn.continue'
                  defaultMessage='Continue'
                />
              </Button>
            </div>
          </form>
        }
      </div>
    )
  }

}

export const Form = reduxForm(formOptions)(DeletionForm)
export const IntlForm = injectIntl(Form)
export default connect(mapStateToProps, mapDispatchToActions, null, { withRef: true })(IntlForm)



// WEBPACK FOOTER //
// ./src/components/deletion/DeletionForm.jsx